import AlgoliaSearchLight from "./AlgoliaSearchLight";
import AlgoliaSearch from "./AlgoliaSearch";
const initAlgoliaSearch = () => {
    // const searchopener = $('.search-opener'),
    //     searchblock = $('.search-block'),
    //     searchactive = 'search-active';
    //
    // const body = document.querySelector('body');
    //
    // searchopener.click(function () {
    //     console.log(searchactive)
    //     body.classList.toggle(searchactive);
    // });

    // $('html').on('click touchstart pointerdown MSPointerDown', function (e) {
    //     var target = $(e.target);
    //     if (
    //         !target.closest(searchopener).length &&
    //         !target.closest(searchblock).length
    //     ) {
    //         $('body').removeClass(searchactive);
    //     }
    // });


    if(document.getElementById('advanced-search-page')) {
        const algoliaSearch = new AlgoliaSearch();
    } else if(document.getElementById('search-quick-field')) {
        const algoliaSearchLight = new AlgoliaSearchLight();
    }
}

export default initAlgoliaSearch
